import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/main-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-0dc103ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "navbar-items" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  href: "#",
  class: "ps-1 active"
}
const _hoisted_7 = { class: "text-start logo" }
const _hoisted_8 = { class: "navbar navbar-expand-lg navbar-light bg-black" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "#"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Vue logo",
    class: "",
    src: _imports_0,
    width: "250"
  })
], -1))
const _hoisted_11 = { id: "navbarNav" }
const _hoisted_12 = { class: "navbar-nav mx-auto" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  href: "#",
  class: "text-start nav-link menuItems active"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-bars hamburger",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "mySidenav",
      class: "sidenav",
      style: _normalizeStyle([_ctx.openMenu ? { width: '250px' } : { width: '0%' }])
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("a", {
          href: "javascript:void(0)",
          class: "closebtn border-0",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openMenu = false))
        }, _hoisted_3)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.name,
              href: "#",
              class: _normalizeClass(["text-start", {
              activeMenu: item.className == _ctx.selectedMenuItem,
            }]),
              onClick: _withModifiers(($event: any) => (_ctx.scrollDownToElement(item.className)), ["prevent"])
            }, [
              _createElementVNode("a", _hoisted_6, _toDisplayString(item.name), 1)
            ], 10, _hoisted_5))
          }), 128))
        ])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("nav", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("ul", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass(["nav-item", {activeMenu: item.className == _ctx.selectedMenuItem}]),
                  key: item.name,
                  onClick: _withModifiers(($event: any) => (_ctx.scrollDownToElement(item.className)), ["prevent"])
                }, [
                  _createElementVNode("a", _hoisted_14, _toDisplayString(item.name), 1)
                ], 10, _hoisted_13))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("span", {
        class: "float-end",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openMenu = true))
      }, _hoisted_16)
    ])
  ]))
}